"use client";

import Link from "next/link";
import { trackNavClick } from "@/lib/gtag";
import { basePath } from "@/lib/basePath";

export default function Header() {
  return (
    <header className="border-b border-amber-200 bg-white/80 backdrop-blur-sm">
      <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-3">
        <Link
          href="/"
          prefetch={false}
          className="flex items-center gap-2 text-xl font-bold text-amber-800"
          onClick={() => trackNavClick("logo")}
        >
          <img
            src={`${basePath}/icon-32.png`}
            alt=""
            width={28}
            height={28}
            className="rounded-lg"
          />
          英文知識王
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          <Link
            href="/words"
            prefetch={false}
            className="flex items-center gap-1 text-amber-700 hover:text-amber-900"
            onClick={() => trackNavClick("搜尋單字")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="h-4 w-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
              />
            </svg>
            搜尋單字
          </Link>
          <Link
            href="/category/toeic"
            prefetch={false}
            className="text-amber-700 hover:text-amber-900"
            onClick={() => trackNavClick("TOEIC")}
          >
            TOEIC
          </Link>
          <Link
            href="/category/daily"
            prefetch={false}
            className="text-amber-700 hover:text-amber-900"
            onClick={() => trackNavClick("日常生活")}
          >
            日常生活
          </Link>
          <Link
            href="/category/phrases"
            prefetch={false}
            className="text-amber-700 hover:text-amber-900"
            onClick={() => trackNavClick("片語")}
          >
            片語
          </Link>
        </nav>
      </div>
    </header>
  );
}
